import React from 'react';
import { clsx } from 'clsx';

import { useMRE } from '../../hooks/useMRE';

import styles from './PrivacyZonesLegend.module.scss';

interface PrivacyZonesLegendProps {
  className?: string;
}

export const PrivacyZonesLegend = ({ className }: PrivacyZonesLegendProps) => {
  const { t } = useMRE();

  return (
    <div
      data-testid="mre-privacy-zones-legend"
      className={clsx(styles.privacyZonesLegend, className)}
    >
      {[
        { color: '#FC5201', label: t('mre.privacy_zones_legend.visible') },
        { color: '#434240', label: t('mre.privacy_zones_legend.hidden') }
      ].map((entry, index) => (
        <div key={`privacy-zone-${index}`} className={styles.section}>
          <svg width="18" height="8">
            <line
              x1="0"
              y1="3"
              x2="18"
              y2="3"
              stroke={entry.color}
              strokeWidth="3px"
            />
          </svg>
          <span className={styles.label}>{entry.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PrivacyZonesLegend;
